
/* Use case: Article/Gallery/HSSN game/etc page with Comments */
ADILF.define('adilf/pages/comments/offcanvas',[
        'streamhub-sdk/jquery', 
        'adilf/context',
        'adilf/handler',
        'adilf/apps/offcanvas/app',
        'adilf/util/utils',
        'adilf/apps/comments/google-analytics',
        'adilf/auth/sdk-auth-delegate',
        'auth',
    ], function(jquery, Context, Handler, OffCanvas, utils, GoogleAnalytics, AuthDelegate, auth) {
    "use strict";

    return {

        init: function() {

            var self = this;

            /* ---------- OffCanvas Component: START ---------- */

            if(window.LF_META && window.LF_META.articleId) {
                var oc = new OffCanvas();
            }

            /* ---------- OffCanvas Component: END ---------- */

        }

    };
});
